// extracted by mini-css-extract-plugin
export var label = "CheckOptions-module--label--2jYXe";
export var checkbox = "CheckOptions-module--checkbox--215hx";
export var checkboxSvg = "CheckOptions-module--checkbox-svg--39b8p";
export var spinAround = "CheckOptions-module--spinAround--3Kkrg";